// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {get, now, orderBy} from 'lodash';

// Core Libs
import downloadExcelFile from '../../lib/core/export';
import {parseJson} from '../../lib/core/object';

// Components
import PanelAction from '../core/panel-action';
import SearchRecordDetails from '../app/search-record-details';
import TableWithSort from '../core/table-with-sort';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'massActionDetail';

class MassActionDetail extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'target',
                title: 'Correlation Id',
                link: '/investigation/mass-action-results/',
                linkKey: 'target',
                type: 'link',
                width: '35%',
            },
            {
                dataKey: 'statusPhrase',
                title: 'Status',
                width: '15%',
            },
            {
                dataKey: 'description',
                title: 'Title',
                width: '50%',
            },
        ];
    }

    getPanelActionProps() {
        return {
            onClick: this.handleExportClick,
            hotkey: 'e',
            icon: 'file-o',
            title: 'Export Data',
            weight: -10,
        };
    }

    getResponseData() {
        const {searchData} = this.props;
        const result = get(searchData, '0.result');

        return orderBy(parseJson(result), ['error', 'statusPhrase', 'description'], ['desc', 'asc', 'asc']);
    }

    getSearchRecordDetailProps() {
        return {
            ...this.props,
            keyOrder: 'massActionResults',
            blacklistKeys: ['result', 'version'],
            keyRenderers: {
                address: this.renderAddress,
            },
        };
    }

    renderAddress = (searchValues, _key) => {
        const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

        if (urlRegex.test(searchValues)) {
            return (
                <a href={searchValues} rel="noreferrer" target="_blank">
                    Download Report
                </a>
            );
        }
        return <>{searchValues}</>;
    };

    handleExportClick = (event) => {
        const {username} = this.props;

        event && event.preventDefault && event.preventDefault();

        const responseData = this.getResponseData();

        if (responseData.length) {
            try {
                downloadExcelFile(responseData, {}, `Mass Actions Result-${now()}.xlsx`, username);
            } catch (error) {
                alert('Export failed. Please try again or contact support if the issue persists.');
            }
        } else {
            alert('No data available to export.');
        }
    };

    renderResult() {
        const responseData = this.getResponseData();

        return responseData ? (
            <TableWithSort
                className="mass-action-detail--table-with-sort"
                columnConfig={this.getColumnConfig()}
                localSort={true}
                notSortable={[]}
                searchData={responseData}
            />
        ) : null;
    }

    renderStatusPhrase = (dataRow) => {
        const {error, statusPhrase} = dataRow;

        return error ? <div className="mass-action-detail--status-error">{statusPhrase}</div> : statusPhrase;
    };

    render() {
        return (
            <div className="mass-action-detail">
                <PanelAction {...this.getPanelActionProps()} />
                <SearchRecordDetails {...this.getSearchRecordDetailProps()} />
                {this.renderResult()}
            </div>
        );
    }
}

MassActionDetail.propTypes = {
    searchData: PropTypes.array,
    username: PropTypes.string,
};

const mapStateToProps = (state) => ({
    username: state.auth.user,
});

export default withSearch(connect(mapStateToProps, null)(MassActionDetail), servicesDataKey);
